<script>import AdaptiveImage from "../components/AdaptiveImage.svelte";
import ButtonBoxPrimary from "../elements/buttons/variants/ButtonBoxPrimary.svelte";
import AdaptiveVideo from "./AdaptiveVideo.svelte";
export let medias;
let selected = 0;
</script>

<div>
	{#each medias as item, index}
		{@html `<${'style'}>.carousel__activator:nth-of-type(${
			index + 1
		}):checked ~ .carousel__controls:nth-of-type(${index + 1}) { display: flex; }</${'style'}>`}
		{@html `<${'style'}>.carousel__activator:nth-of-type(${
			index + 1
		}):checked ~ .carousel__screen .carousel__track { transform: translateX(${
			index * -100
		}%); }</${'style'}>`}
	{/each}
	<div class="carousel">
		{#each medias as item, index}
			<input
				id="carousel-activator-{index}"
				class="carousel__activator"
				type="radio"
				name="activator"
				value={index}
				bind:group={selected}
			/>
		{/each}

		{#each medias as item, index}
			<div class="carousel__controls">
				<label
					class="carousel__control carousel__control--backward mr-1 z-1 cursor-pointer"
					for="carousel-activator-{index - 1}"
					class:cursor-not-allowed={index === 0}
				>
					<ButtonBoxPrimary
						props={{
							iconLeft: 'arrow_left',
							size: 'small',
							classNames: 'pointer-events-none',
							roundedFull: true,
							disabled: index === 0
						}}
					/>
				</label>
				<label
					class="carousel__control carousel__control--forward ml-1 z-1 cursor-pointer"
					for="carousel-activator-{index + 1}"
					class:cursor-not-allowed={index === medias.length - 1}
				>
					<ButtonBoxPrimary
						props={{
							iconLeft: 'arrow_right',
							size: 'small',
							classNames: 'pointer-events-none',
							roundedFull: true,
							disabled: index === medias.length - 1
						}}
					/>
				</label>
			</div>
		{/each}

		<div class="carousel__screen">
			<div class="carousel__track">
				{#each medias as item, index}
					<div class="carousel__item relative">
						{#if index > 0}
							<div class="carousel__item-title">
								<div>{item.title}</div>
							</div>
						{/if}
						{#if item.url}
						<div
							class="w-full {item.isVideo && index === 0 ? '' : 'aspect-video'}"
						>
							{#if item.isVideo && index === 0}
								<AdaptiveVideo
									src={item.url}
									iframeTitle={item.title}
									ratio="aspect-video"
									iframe={true}
								/>
							{:else}
								<AdaptiveImage
									src={item.url}
									alt={item.title}
									classNames="w-full h-full object-cover"
								/>
							{/if}
						</div>
							{/if}
					</div>
				{/each}
			</div>
		</div>
	</div>
</div>

<style>.carousel{align-items:center;display:flex;justify-content:center;padding-bottom:3rem;position:relative;width:100%}.carousel__activator{display:none}.carousel__controls{align-items:center;bottom:0;display:none;position:absolute;right:0}.carousel__screen{overflow:hidden;width:100%}.carousel__track>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:1rem;margin-left:calc(1rem*(1 - var(--tw-space-x-reverse)));margin-right:0;margin-right:calc(1rem*var(--tw-space-x-reverse))}.carousel__track{transition-duration:.3s;transition-property:all;transition-timing-function:cubic-bezier(.4,0,.2,1);white-space:nowrap}@media (min-width:1024px){.carousel__track>:not([hidden])~:not([hidden]){--tw-space-x-reverse:0;margin-left:0;margin-left:calc(0px*(1 - var(--tw-space-x-reverse)));margin-right:0;margin-right:calc(0px*var(--tw-space-x-reverse))}}.carousel__track{font-size:0;-webkit-overflow-scrolling:touch}.carousel__item{display:inline-flex;vertical-align:top;white-space:normal;width:75%}@media (min-width:1024px){.carousel__item{width:100%}}@media screen and (max-width:1023px){.carousel__activator:nth-of-type(n):checked~.carousel__controls:nth-of-type(n){display:none}.carousel__activator:nth-of-type(n):checked~.carousel__screen .carousel__track{transform:none}.carousel__track{overflow-x:auto;width:auto}}.carousel__item-title{align-items:center;background-image:linear-gradient(to bottom,var(--tw-gradient-stops));bottom:0;display:flex;left:0;min-height:30px;position:absolute;right:0;z-index:1;--tw-gradient-from:transparent var(--tw-gradient-from-position);--tw-gradient-to:transparent var(--tw-gradient-to-position);--tw-gradient-stops:var(--tw-gradient-from),var(--tw-gradient-to);--tw-gradient-to:var(--color-secondary) var(--tw-gradient-to-position);font-size:.875rem;line-height:1.25rem;padding:.5rem 1rem;--tw-text-opacity:1;color:#fff;color:rgba(255,255,255,var(--tw-text-opacity,1))}@media (min-width:1024px){.carousel__item-title{min-height:60px}}</style>
